<template>
    <section
        class="i-esg-ratings">
        <h3
            class="i-esg-ratings__header"
            :title="esgRatingsData.name"
            v-html="esgRatingsData.name"></h3>
        <ul class="i-esg-ratings__list">
            <li
                v-for="(item, i) in esgRatingsData.items"
                class="i-esg-ratings__item">
                <div class="i-esg-ratings__img">
                    <img
                        :src="item.icon_src"
                        :alt="esgRatingsData.name"
                        :title="esgRatingsData.name" />
                </div>
                <div class="i-esg-ratings__wrap">
                    <p
                        class="i-esg-ratings__desc"
                        v-html="item.values_ratings"></p>
                    <a
                        v-if="item.link_url"
                        class="i-esg-ratings__link"
                        :href="item.link_url"
                        :title="item.link_title"
                        target="_blank"
                        v-html="item.link_title"></a>
                </div>
            </li>
        </ul>
    </section>
</template>

<script>
    export default {
        name: 'EsgRatings',
        props: {
            esgRatingsData: {
                type: Object,
                default: () => {}
            }
        }
    }
</script>